module.exports = __webpack_public_path__ + "img/40.10.pH.7155bbdc.png";